export const PHONE_COUNTRY_OPTIONS = [
  { value: "NL", label: "🇳🇱 +31" },
  { value: "DE", label: "🇩🇪 +49" },
  { value: "BE", label: "🇧🇪 +32" },
] as const;

export type PhoneCountryCode = (typeof PHONE_COUNTRY_OPTIONS)[number]["value"];

export const DEFAULT_PHONE_COUNTRY: PhoneCountryCode = "NL";

export const isPhoneCountryCode = (value: unknown): value is PhoneCountryCode =>
  typeof value === "string" &&
  PHONE_COUNTRY_OPTIONS.some((c) => c.value === value);
